import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Enum } from '../model/enum';

@Injectable()
export class BLEnum {

    constructor(
        private dataService: DataService,
        private http: HttpClient) {
    }

    list(code: string, language: string): Promise<Enum[]> {
        const url = 'enum?code=' + code + '&language=' + language;
        return new Promise<Enum[]>((resolve, reject) => {
            this.http.get<Enum[]>(this.dataService.getApiEndpoint(url)).subscribe(data => {
                resolve(data);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/bl/blenum.ts